import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Input, Button, Tooltip, Modal, message } from "antd";
import { request, BaseComponent } from '@cm-sites-webber/components';

import './style.css';
import { PositionTypeContext } from '../../PositionAdd';
const InputProps = {...Input.defaultProps,...Input.propTypes,onChange:()=>{}}

/**
 * 名称验证输入框
 */
class NameCheck extends BaseComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: ""
        };

        this.suffixDomRef = React.createRef();
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .name-check .rmt-input-suffix-layout`);
        if (this.suffixDomRef.current) {
            observer.observe(this.suffixDomRef.current);
        }else {
            this.setState({
                suffixWidth: 0,
            })
        }
        this.updateValue();
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(NameCheck.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            
            return {...state,fieldProps:{...newProps}}
        }
        return state
    }


    renderSuffixButton() {
        // buttonDisabled= false
        const { buttonProps={},positionTypeId, disabled } = this.props.fieldProps;
        return (
            <PositionTypeContext.Consumer>
                {(value) => {
                    const buttonDisabled = value.positionTypeItem?.type&&(value.positionTypeItem?.type ===2 ||value.positionTypeItem?.type ===3) ? false : true;
                    return (
                        <>
                            {
                                buttonDisabled ? (
                                    <Tooltip title="只有公众号，微博类型的账号才能验证名称">
                                        <Button 
                                            {...buttonProps}
                                            disabled={buttonDisabled || disabled}
                                            // onClick={e=>this.checkName(id)}
                                        >验证名称</Button>
                                    </Tooltip>
                                ): (
                                    <Button 
                                            {...buttonProps}
                                            disabled={buttonDisabled || disabled}
                                            type="primary"
                                            onClick={e=>this.checkName(positionTypeId)}
                                        >验证名称</Button>
                                )
                            }
                        </>
                    )
                }}
            </PositionTypeContext.Consumer>
        )
    }

    render() {
        const { prefixLayout, suffixLayout, style={}, suffixButton } = this.props.fieldProps;
        const { fieldProps, suffixWidth } =this.state;
        return (
            <>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children .name-check ~ .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                    }
                </style>
                <div className="rmt-input name-check">
                    <div className="rmt-input-content-layout" style={style}>
                        <Input {...fieldProps} id={this.props.name} value={this.state.value} onChange={(e)=>{
                            this.setState({value:e.target.value})
                            fieldProps.onChange(e.target.value);
                        }} />
                    </div>
                    {/*<div className="rmt-input-suffix-layout" ref={this.suffixDomRef}>{this.renderSuffixButton()}</div>*/}
                </div>
            </>
        )
    }

    // 验证名称
    checkName(id) {
        const body = {id, name:this.state.value}
        if (!body.name) {
            message.destroy();
            message.warning("请输入账号名称");
            return;
        }
        this.request({
            url: "/cm-sites-media-consumer/position/management/checkName",
            body,
            contentType: "json",
            callBack:(response)=>{
                if (response) {
                    const data = JSON.parse(response);
                    const { account } = data;
                    Modal.success({
                        content: '账号名称验证成功！',
                        centered: 'centered',
                        okText: "确定",
                        onOk: () => {
                            typeof  this.props.fieldProps?.getPositionAccount === "function" && this.props.fieldProps.getPositionAccount({account});
                        }
                    });
                }
            },
            errorCallBack: (error)=>{
                Modal.warning({
                    content: '账号名称验证失败！',
                    centered: 'centered',
                    okText: "确定",
                })
            },
        })
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }

}
export default NameCheck;

NameCheck.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

NameCheck.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: ()=>{}
}